/**
 * UI Store — sidebar and global UI state
 */
import { proxy } from 'valtio'

export interface UIState {
  sidebarCollapsed: boolean
}

const initialState: UIState = {
  sidebarCollapsed: false,
}

export const uiStore = proxy<UIState>(initialState)

export const toggleSidebar = () => {
  uiStore.sidebarCollapsed = !uiStore.sidebarCollapsed
}

export const setSidebarCollapsed = (collapsed: boolean) => {
  uiStore.sidebarCollapsed = collapsed
}
